import { Document } from './../../model/document.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-editor-policy',
  templateUrl: './editor-policy.component.html',
  styleUrls: ['./editor-policy.component.css']
})
export class EditorPolicyComponent implements OnInit {
  @Input() document: Document;

  constructor() { }

  ngOnInit() {
  }

}
